<template>
  <div style="width:50%; left:25%; position:relative; margin-top:15px;">
    <Table :max-height="height * 0.6" border ref="selection" :columns="columns4" :data="data1">
      <template slot-scope="{ row, index }" slot="selection">
        <Checkbox @on-change="selectRow(row, $event)"></Checkbox>
      </template>
    </Table>

    <div style="padding:10px">
      <Button style type="error" @click="delAbnormalPush">删除</Button>
      <Button style="margin-left:10px" type="success" @click="showAddModal=true">新增</Button>
    </div>

    <Modal title="Title" v-model="showAddModal" :mask-closable="false" width="380">
      <p slot="header" style="color:#0066FF;text-align:center">
        <Icon type="md-create"/>
        <span>选择异常类型</span>
      </p>
      <div style="text-align:center">
        <Row class="row">
          <Col span="12">
            <p>异常类型</p>
          </Col>
          <Col span="12">
            <Select v-model="selectCommand" style="width:150px" placeholder="请选择命令字">
              <Option
                v-for="(value, key) in errorSelection"
                v-if="existArray.indexOf(key) < 0"
                :value="key + ',' +  value.name"
                :key="key"
              >{{key}}--{{value.name}}</Option>
            </Select>
          </Col>
        </Row>
      </div>
      <div slot="footer">
        <Button type="info" size="large" long @click="addAbnormalPush">添加</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { constants } from "crypto";
export default {
  name: "set_up_repair_list",
  mounted() {
    this.getRepariAbnormalList();
  },
  data() {
    return {
      existArray: [],
      selectCommand: "",
      errorSelection: global.errorMsgParam,
      showAddModal: false,
      selectData: {},
      height: document.body.clientHeight,
      width: document.body.clientWidth,
      columns4: [
        {
          title: " ",
          slot: "selection",
          width: 60,
          align: "center"
        },
        {
          title: "异常序号",
          key: "infoPushExceptionMsgIndex",
          align: "center"
        },
        {
          title: "异常类型",
          key: "infoPushExceptionMsgName",
          align: "center"
        }
      ],
      data1: []
    };
  },
  methods: {
    delAbnormalPush() {
      if (Object.keys(this.selectData).length == 0) {
        this.$Modal.info({
          title: "提示",
          content: "请选择需删除信息！"
        });
        return;
      }

      var that = this;
      $.ajax({
        url: "/api/delAbnormalRepairSetting",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          delInfo: that.selectData
        }),
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Modal.error({
              title: "提示",
              content: data.errorInfo
            });

            return;
          } else {
            // 当前用户微信未进行绑定
            that.$Modal.success({
              title: "提示",
              content: "删除成功"
            });
          }
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口调用异常"
          });
        },
        complete: function(XMLHttpRequest, textStatus) {
          that.getRepariAbnormalList();
        }
      });
    },
    addAbnormalPush() {
      if (this.selectCommand == "") {
        this.$Modal.info({
          title: "提示",
          content: "请选择新增异常类型！"
        });
        return;
      }

      var that = this;
      $.ajax({
        url: "/api/addAbnormalRepairSetting",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          addInfo: that.selectCommand
        }),
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Modal.error({
              title: "提示",
              content: data.errorInfo
            });

            return;
          } else {
            // 当前用户微信未进行绑定
            that.$Modal.success({
              title: "提示",
              content: "新增成功"
            });
          }
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口调用异常"
          });
        },
        complete: function(XMLHttpRequest, textStatus) {
          that.getRepariAbnormalList();
          that.showAddModal = false;
        }
      });
    },
    selectRow(row, result) {
      if (result) {
        this.selectData[row.infoPushExceptionMsgId] = row;
      } else {
        delete this.selectData[row.infoPushExceptionMsgId];
      }
      //   console.log(this.row);
      console.log(this.selectData);
    },
    handleSelectAll(status) {
      console.log(this.$refs.selection);
    },
    getRepariAbnormalList() {
      var that = this;
      that.existArray = [];
      $.ajax({
        url: "/api/getAbnormalRepairList",
        contentType: "application/json",
        type: "get",
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            that.result = "fail";
            return;
          }

          //   that.meters = data.body;
          that.data1 = data.body;
          that.data1.forEach(function(value, i) {
            that.existArray.push(value.infoPushExceptionMsgIndex);
          });
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "获取信息异常"
          });
          that.result = "fail";
        },
        complete: function(XMLHttpRequest, textStatus) {}
      });
    }
  }
};
</script>